import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
/**
 * API Class
 */
@Injectable()
export class Client {
  static _(http: HttpClient) {
    return new Client(http);
  }

  constructor(public http: HttpClient) {}

  /**
   * Return a GET request
   */
  public get(endpoint: string, options: Object = {}) {
    const self = this;
    const acceptJSON = new HttpHeaders().set("Accept", "application/json");

    if (Object.keys(options).length !== 0) {
      endpoint += "?" + this.buildParams(options);
    }

    return new Promise((resolve, reject) => {
      self.http
        .get(environment.backendBaseUrl + "/" + endpoint, {
          headers: acceptJSON
        })
        .subscribe(
          (res) => {
            if (!res) {
              return reject(res);
            }
            return resolve(res);
          },
          (err) => {
            return reject(err);
          }
        );
    });
  }

  /**
   * Return a POST request
   * @TODO: error reject json
   */
  public post(endpoint: string, data: Object = {}) {
    const self = this;
    const acceptJSON = new HttpHeaders().set("Accept", "application/json");
    return new Promise((resolve, reject) => {
      self.http
        .post(environment.backendBaseUrl + "/" + endpoint, data, {
          headers: acceptJSON
        })
        .subscribe(
          (response) => {
            if (!response) {
              return reject(response);
            }
            return resolve(response);
          },
          (err) => {
            return reject(err);
          }
        );
    });
  }

  /**
   * Return a PUT request
   * @TODO: error reject json
   */
  public put(endpoint: string, data: Object = {}) {
    const self = this;
    const acceptJSON = new HttpHeaders().set("Accept", "application/json");
    return new Promise((resolve, reject) => {
      self.http
        .put(environment.backendBaseUrl + "/" + endpoint, data, {
          headers: acceptJSON
        })
        .subscribe(
          (response) => {
            // var data = response;
            if (!response) {
              return reject(response);
            }
            return resolve(response);
          },
          (err) => {
            return reject(err);
          }
        );
    });
  }

  public postLogin(endpoint: string, data: Object = {}) {
    const self = this;
    const customHeaders = new HttpHeaders().set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    return new Promise((resolve, reject) => {
      self.http
        .post(
          environment.backendBaseUrl + "/" + endpoint,
          this.buildParams(data),
          {
            headers: customHeaders
          }
        )
        .subscribe(
          (response) => {
            if (!response) {
              return reject(response);
            }
            return resolve(response);
          },
          (err) => {
            return reject(err);
          }
        );
    });
  }

  /**
   * Return a DELETE request
   * @TODO: error reject json
   */
  public delete(endpoint: string) {
    const self = this;
    const acceptJSON = new HttpHeaders().set("Accept", "application/json");
    return new Promise((resolve, reject) => {
      self.http
        .delete(environment.backendBaseUrl + "/" + endpoint, {
          headers: acceptJSON
        })
        .subscribe(
          (response) => {
            // var data = response;
            if (!response) {
              return reject(response);
            }
            return resolve(response);
          },
          (err) => {
            return reject(err);
          }
        );
    });
  }

  private buildParams(object: Object) {
    return Object.keys(object)
      .map((k) => {
        return encodeURIComponent(k) + "=" + encodeURIComponent(object[k]);
      })
      .join("&");
  }
}
